export default (number) => {
  if (!number) {
    return null;
  }
  return Math.round((number + Number.EPSILON) * 100) / 100;
};
